<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright-page">
<p class="copy1">Publisher: Amy Barrett-Daffin</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Senior Editor: Roxane Cerda</p>
<p class="copy">Editor: Karen Costello Soltys</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Illustrator: Missy Shepler of Shepler Studios</p>
<p class="copy">Quiltmaking Basics illustrations by Sandy Loi</p>
<p class="copy">Photography Coordinator: Rachel Ackley</p>
<p class="copy">Front cover and lifestyle photography by Adam Albright</p>
<p class="copy">Photography, Inc.</p>
<p class="copy">Cover and lifestyle styling by Jennifer Keltner of Snappy Style</p>
<p class="copy">Subject and instructional Photography by C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy1">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?9b561e9c